import { takeLatest, put } from 'redux-saga/effects';
import { authentication } from 'state/api/authentication';
import { withToken, genFetch } from 'state/utils/endpoints/request-helper';
import * as navigationActions from './actions';
import navigationTypes from './types';
import { SagaRequest, RequestType, reqHandler } from 'coral-utility';

interface ICoreResponse {
  data: any;
  message: string;
}

function* getNavigationItems() {
  try {
    const request: SagaRequest = {
      onFetch: () => genFetch(authentication.getNavigation())(withToken())(),
      onSuccess: (coreJsonResponse: any) =>
        put(navigationActions.getNavigationSuccessAction(coreJsonResponse.data)),
      onFailure: () => put(navigationActions.getNavigationFailureAction()),
      onDeserialize: 'json',
      type: RequestType.ONE,
    };

    yield reqHandler(request);
  } catch (error) {
    console.log(error); // tslint:disable-line:no-console
  }
}

export default function* connectSaga() {
  yield takeLatest(navigationTypes.GET_NAVIGATION_ITEMS, getNavigationItems);
}
